import { Pipe, PipeTransform } from '@angular/core';
import { differenceInCalendarDays } from 'date-fns';

@Pipe({
  standalone: false,
  name: 'liteCalReservationLengthOffset',
})
export class LiteCalReservationLengthOffsetPipe implements PipeTransform {
  transform(reservation: any): any {
    const startDate = new Date(reservation.start_date);
    const endDate = new Date(reservation.end_date);

    const lengthOfReservationInDays = differenceInCalendarDays(endDate, startDate);

    return lengthOfReservationInDays * 40;
  }
}
